var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cms-block-stub"},[_c('small',{staticClass:"cms-block-stub__name"},[_vm._v("PLACEHOLDER BLOCK")]),_c('span',{staticStyle:{"color":"red","padding":"6px"}},[_vm._v("Блок \""+_vm._s(_vm.blockName)+"\" не найден")])])
}
var staticRenderFns = []

export { render, staticRenderFns }